import React, { useRef } from 'react';
import './otp.scss';

const OTPInput = ({
	value = '',
	onChange,
	length = 4,
	className = '',
	inputClassName = '',
	idPrefix = 'otp',
	onComplete,
}) => {
	const inputsRef = useRef([]);
	const digits = Array.from({ length }, (_, index) => value[index] || '');

	const updateValue = (index, input) => {
		const enteredDigits = input.replace(/\D/g, '');
		const nextDigits = [...digits];

		if (enteredDigits.length > 1) {
			enteredDigits.slice(0, length - index).split('').forEach((digit, offset) => {
				nextDigits[index + offset] = digit;
			});
		} else {
			nextDigits[index] = enteredDigits;
		}

		const nextValue = nextDigits.join('');
		onChange?.(nextValue);

		if (enteredDigits.length > 1) {
			inputsRef.current[Math.min(index + enteredDigits.length, length) - 1]?.focus();
		} else if (enteredDigits && index < length - 1) {
			inputsRef.current[index + 1]?.focus();
		}

		if (nextDigits.every(Boolean)) {
			onComplete?.(nextValue);
		}
	};

	const handleKeyDown = (event, index) => {
		if (event.key === 'Backspace' && !digits[index] && index > 0) {
			inputsRef.current[index - 1]?.focus();
		}
	};

	const handlePaste = (event, index) => {
		const pastedDigits = event.clipboardData.getData('text').replace(/\D/g, '');
		if (!pastedDigits) return;

		event.preventDefault();
		updateValue(index, pastedDigits);
	};

	return (
		<div className={`otp-container ${className}`.trim()}>
			{digits.map((digit, index) => (
				<input
					key={index}
					ref={(element) => { inputsRef.current[index] = element; }}
					id={`${idPrefix}-${index}`}
					type="text"
					inputMode="numeric"
					pattern="[0-9]*"
					autoComplete={index === 0 ? 'one-time-code' : 'off'}
					aria-label={`Digit ${index + 1}`}
					maxLength={length}
					className={inputClassName}
					value={digit}
					onChange={(event) => updateValue(index, event.target.value)}
					onKeyDown={(event) => handleKeyDown(event, index)}
					onPaste={(event) => handlePaste(event, index)}
				/>
			))}
		</div>
	);
};

export default OTPInput;
